import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import IntegrationCard from "./IntegrationCard";
import MiroConnectionCard from "pages/Account/components/MiroConnectionCard";
import useMiroConnection from "hooks/useMiroConnection";
import { PATHS } from "router/config/paths";

const LINK = "text-purpleGreen underline";

/**
 * The Miro card of the Integrations hub (REF-6702): connection (Connect / Reconnect / Disconnect, returning HERE) and a short
 * "Where to use Miro" list. The import and export actions live in their real homes (Design Assets → Import from Miro, Design Canvas →
 * Import from Miro, the Export menus) — this card only points at them.
 */
const MiroIntegration = () => {
  const { t } = useTranslation();
  const connection = useMiroConnection(true);

  if (!connection.isLoading && !connection.isAvailable) {
    return <IntegrationCard brand="miro" data-testid="miro-hub-unavailable" name={t("miro:account.title")} description={t("miro:unavailable")} />;
  }

  return (
    <div className="min-w-0" data-testid="miro-hub">
      <MiroConnectionCard returnTo={PATHS.INTEGRATIONS} surface="integrations" connection={connection}>
        <div className="flex flex-col gap-1.5 border-t border-black-300 pt-3" data-testid="miro-hub-where">
          <h6 className="text-head7 text-white">{t("miro:hub.where_heading")}</h6>
          <ul className="flex list-disc flex-col gap-1 ps-4 text-white/70">
            <li>
              {t("miro:hub.where_import_images")}{" "}
              <Link to={PATHS.DESIGN_ASSETS} data-testid="miro-hub-link-assets" className={LINK}>
                {t("common:nav.design_assets")}
              </Link>
            </li>
            <li>
              {t("miro:hub.where_import_board")}{" "}
              <Link to={PATHS.CANVAS_PROJECTS} data-testid="miro-hub-link-canvas" className={LINK}>
                {t("miro:hub.design_canvas")}
              </Link>
            </li>
            <li data-testid="miro-hub-export-note">{t("miro:hub.where_export")}</li>
          </ul>
        </div>
      </MiroConnectionCard>
    </div>
  );
};

export default MiroIntegration;
